
import { __callbacks } from "Utils/Callbacks/Callback";
import { __chatQueue } from "Utils/ChatQueue/ChatQueue";
import { useCallback, useEffect, useState } from "react";
import styles from "./ButtonBack.module.scss";


export default function ButtonBack(props: any) {

  const [buttonBlack,] = useState(props.black);
  const [buttonWhite, setButtonWhite] = useState(props.white);
  const [classHover, setClassHover] = useState("");
  const [fill, setFill] = useState("white");
  const [notificationNo, setNotificationNo] = useState<number>(0);
  const [classNotificationHide, setClassNotificationHide] = useState(styles.hide);

  const initEvents = useCallback(
      () => {

      // listen to chat message event to know unread messages 
      __callbacks.onChatMessage(() => {
        const allMsgs = __chatQueue.allMsgs();
        setNotificationNo(allMsgs);
      });

      const allMsgs = __chatQueue.allMsgs();
      setNotificationNo(allMsgs);
    },
    [],
  )
  

  useEffect(() => {
    if(!buttonBlack && !buttonBlack) {
      setButtonWhite(true);
    }
  }, [buttonBlack, buttonWhite]);

  useEffect(() => {
    if(!buttonBlack) return;
    setFill("black");
    setClassHover(styles["hover-black"]);
  }, [buttonBlack]);

  useEffect(() => {
    if(!buttonWhite) return;
    setFill("white");
    setClassHover(styles["hover-white"]);
  }, [buttonWhite]);

  const onClicks = () => {
    //__callbacks.onButtonBackClick.trigger({data: "you click on button back"});
    __callbacks.updateAppState.trigger({appState: props.backState});
  }

  useEffect(() => {
    if(notificationNo < 1) {
      setClassNotificationHide(styles.hide);
    }
    else {
      setClassNotificationHide("");
    }
  }, [notificationNo]);

  useEffect(() => {
    initEvents();
  }, [initEvents]);

  return (
    <div className={`${styles["btn-back"]} ${classHover}`} onClick={onClicks}>
      <svg xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71" fill="none">
        <path d="M15.9099 35.0018L43.1335 7.77818L35.3553 0L3.88908 31.4663L5.96048e-07 35.3553L35.3553 70.7107L43.4871 62.579L15.9099 35.0018Z" fill={fill} />
      </svg>
      <div className={`${styles["notification"]} ${classNotificationHide}`}>{notificationNo}</div>
    </div>
  )
}
